import React from 'react';
import Estatus from '../../componentes/Estatus';
import Listados from '../../contenedores/Listados';
import { UNIDADES_MEDIDA } from '../../configuraciones/endpoints';

const cabeceros = [
  { label: 'nombre', key: 'nombre' },
  { label: 'Nombre corto', key: 'nombreCorto' },
  { label: 'Estatus', transform: ({ estatus }) => <Estatus activo={estatus} /> },
];

const UnidadesMedida = ({ history, location }) => {

  return <Listados
    titulo="Unidades de medida"
    placeHolder="Búsqueda por nombre"
    history={history}
    location={location}
    showActions
    cabeceros={cabeceros}
    apiKey={UNIDADES_MEDIDA}
  />;
};

export default UnidadesMedida;